"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useDeleteInsuranceCard = exports.useUploadInsuranceCard = exports.useGetInsuranceCards = exports.useGetInsuranceCardTypes = void 0;
var insurance_1 = require("../insurance");
var react_query_1 = require("react-query");
var react_query_2 = require("react-query");
function useGetInsuranceCardTypes(disabled) {
    if (disabled) {
        return (0, react_query_1.useQuery)(["getInsuranceCardTypes"], insurance_1.getCardTypes, { enabled: false });
    }
    return (0, react_query_1.useQuery)(["getInsuranceCardTypes"], insurance_1.getCardTypes);
}
exports.useGetInsuranceCardTypes = useGetInsuranceCardTypes;
function useGetInsuranceCards(patientId) {
    return (0, react_query_1.useQuery)(["getInsuranceCards", patientId], function () { return (0, insurance_1.getCards)(patientId); });
}
exports.useGetInsuranceCards = useGetInsuranceCards;
function useUploadInsuranceCard(options) {
    var queryClient = (0, react_query_1.useQueryClient)();
    return (0, react_query_2.useMutation)(insurance_1.uploadCard, __assign(__assign({}, options), { onSuccess: function () { return queryClient.invalidateQueries(["getInsuranceCards"]); } }));
}
exports.useUploadInsuranceCard = useUploadInsuranceCard;
function useDeleteInsuranceCard(options) {
    var queryClient = (0, react_query_1.useQueryClient)();
    return (0, react_query_2.useMutation)(insurance_1.deleteCard, __assign(__assign({}, options), { onSuccess: function () { return queryClient.invalidateQueries(["getInsuranceCards"]); } }));
}
exports.useDeleteInsuranceCard = useDeleteInsuranceCard;
